import React from 'react';

const Remarks = ({ remarks }) => (
  <section className="py-16 text-center bg-purple-50">
    <h2 className="text-3xl font-semibold text-purple-800 mb-8">Customer Remarks</h2>
    <div className="flex flex-wrap justify-around px-4 md:px-8 lg:px-16">
      {remarks.map((remark, index) => (
        <div key={index} className="border border-purple-200 p-6 m-4 rounded-lg bg-purple-100 max-w-sm">
          <h3 className="text-xl font-semibold mb-2">{remark.name}</h3>
          <p className="text-gray-600">"{remark.comment}"</p>
          <div className="text-yellow-500">
            {Array.from({ length: remark.rating }, (_, i) => (
              <span key={i}>⭐</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default Remarks;